import { handleActions } from 'redux-actions'
import { createSelector } from 'reselect'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setCompanyCaseManagers } from 'src/store/modules/actionCreators'
import { companySelector } from 'src/store/modules/company/selectors'

import { COMPANY_CASE_MANAGERS } from 'src/constants'
import { addAllValue } from 'src/utils/DataTrees'

/* --------- reducer --------- */
const initialState = []

export default handleActions(
  {
    [setCompanyCaseManagers](state, { payload = [] }) {
      return [...payload]
    }
  },
  initialState
)

/* --------- thunks --------- */
export const getCaseManagers =
  ({ query = {} }) =>
  async (dispatch) => {
    try {
      const { items = [] } = await httpClient.get({
        pathname: COMPANY_CASE_MANAGERS,
        query: {
          sort: 'fullName:asc',
          ...query
        }
      })

      dispatch(setCompanyCaseManagers(items))

      return items
    } catch (err) {
      catchError(err)
    }
  }

/* --------- selectors --------- */
export const companyCaseManagersSelector = createSelector(
  companySelector,
  ({ caseManagers = [] }) =>
    caseManagers.map((manager, key) => ({
      ...manager,
      key,
      disabled: manager.availableEmployees <= 0,
      value: manager.uuid,
      title: manager.fullName
    }))
)

export const companyCaseManagersWithAll$ = createSelector(
  companyCaseManagersSelector,
  (caseManagers = []) => addAllValue(caseManagers, true, 'All')
)

export const companyCaseManagersClearSelector = createSelector(
  companySelector,
  (company) => company.caseManagers
)
